import { currentAccessToken } from '../auth/useAuth';

const KEY = 'codeframe.proxyUrl';

function viteEnv(): { VITE_CODEFRAME_PROXY_URL?: string; VITE_CODEFRAME_WS_TOKEN?: string } {
  return (import.meta as unknown as { env?: { VITE_CODEFRAME_PROXY_URL?: string; VITE_CODEFRAME_WS_TOKEN?: string } }).env ?? {};
}

export function proxyUrl(): string {
  const stored = (typeof localStorage !== 'undefined' && localStorage.getItem(KEY)) || '';
  const env = viteEnv();
  const base = stored || env.VITE_CODEFRAME_PROXY_URL || 'ws://localhost:8787';
  // Prod: the live Cognito access token gates the WS (proxy verifies the JWT).
  // Dev: fall back to the static VITE token. The proxy decides which it expects.
  const token = currentAccessToken() ?? env.VITE_CODEFRAME_WS_TOKEN;
  if (!token) return base;
  // A localStorage override may already include its own query string.
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}token=${encodeURIComponent(token)}`;
}

export function setProxyUrl(u: string): void { localStorage.setItem(KEY, u); }

/**
 * HTTP(S) base for the proxy's non-WS routes (e.g. `/stock/search`), derived
 * from the configured ws(s):// proxy URL: ws→http, wss→https, with any `?token`
 * query stripped (the stock route is origin-gated, not token-gated).
 */
export function proxyHttpBase(): string {
  const stored = (typeof localStorage !== 'undefined' && localStorage.getItem(KEY)) || '';
  const env = viteEnv();
  const base = stored || env.VITE_CODEFRAME_PROXY_URL || 'ws://localhost:8787';
  const noQuery = base.split('?')[0]!.replace(/\/+$/, '');
  return noQuery.replace(/^ws:\/\//, 'http://').replace(/^wss:\/\//, 'https://');
}
